/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

// <<<<<<<<<<<<<<<<<<<<<< ---------------------- CUSTOM EVENT TRACKER ---------------------- >>>>>>>>>>>>>>>>>>>>> //
// this will be what we ACTUALLY import into our files
// this will act as middleware between our app and fkp so that we can more easily move to different providers without touching a ton of files

import { initTracking } from '@insticator/fe-utils/src/tracking/tracking';
import { makePOSTRequest } from "utils/api/makePOSTRequest";
import { createEventData } from 'utils/tracking/fkp/fkp';
import { url } from 'utils/urls'

// <<<<<<<<<<<<<<<<<<<<<< ---------------------- CUSTOM EVENT TRACKER ---------------------- >>>>>>>>>>>>>>>>>>>>> //

const { trackEvent } = initTracking({
  basePath: url.events,
  sendFunction: makePOSTRequest,
  createEventData: createEventData
})

/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export { trackEvent };
